<template>
  <div class="filtro">
    <data-table-consulta-comp class="margin-top: 50px;"
      :colNames="colNames"
      :eventBusDataName="eventBusDataName"
      :eventBusDataPaginationName="eventBusDataPaginationName"
      :dataTableColumn="dataTableColumn"
      :colWidth="colWidth">

      <template v-slot:default="slotProps">
        <td style="text-align: center; width: 100px !important;">
          <i class="fa fa-search fa-1-5x" aria-hidden="true" v-on:click="visualizar(slotProps.itemData.numeroProcessoFormatado)"></i>
        </td>
      </template>
    </data-table-consulta-comp>
  </div>
</template>

<script>
import dataTableConsultaComp from '@/components/data-table-consulta/DataTableConsultaComp'
import DataValues from '@/components/data-table-consulta/DataValues'

import eventBus from '@/uteis/eventBus'
import ReservaProtocoloService from '@/services/ReservaProtocoloService'

export default {
  components: {
    dataTableConsultaComp
  },

  data () {
    return {
      colNames: ['Número Protocolo', 'Tipo do Protocolo', 'Ações'],
      eventBusDataName: 'adicionarReservaProtocolo',
      dataTableColumn: ['numeroProcessoFormatado', 'tipoProtocolo'],
      eventBusDataPaginationName: 'adicionarReservaProtocoloDataPagination',
      rowsNumber: 10,
      colWidth: [40, 40, 20],
      filtro: {
        idReservaProtocolo: ''
      }
    }
  },

  methods: {
    visualizar (numeroProcesso) {
      this.$router.push({ name: 'manterElaboracao', query: { numeroProcesso, reserva: true } })
    },

    popularTabela (data, pagina) {
      const dataValues = new DataValues(data, pagina, this.rowsNumber)
      dataValues.dataTableColumn = this.dataTableColumn

      eventBus.$emit(this.eventBusDataName, dataValues)
    },

    buscarNumerosProcesso (pagina) {
      this.service.buscarReservaProtocolo(this.filtro.idReservaProtocolo).then((response) => {
        var numerosProcessos = response.data[0].numerosProcessos
        this.popularTabela(numerosProcessos, pagina)
      }).catch(err => {
        console.log(err)
      })
    },

    trocaDePagina (numeroPagina) {
      this.buscarNumerosProcesso(numeroPagina)
    }
  },

  created () {
    this.filtro.idReservaProtocolo = this.$route.query.idReservaProtocolo
    this.service = new ReservaProtocoloService()

    this.buscarNumerosProcesso(1)

    eventBus.$on(this.eventBusDataPaginationName, (numeroPagina) => {
      this.trocaDePagina(numeroPagina)
    })
  },

  destroyed () {
    eventBus.$off(this.eventBusDataPaginationName)
  }
}
</script>

<style lang="scss" scoped>
.filtro {
  .msgContatoExistente {
    color: red;
    margin-top: 8px;
    left: 17%;
    position: relative;
  }

  .interessados > label, a {
    margin-top: 15px;
  }
}
</style>
